// extracted by mini-css-extract-plugin
export default {"quizAnimationContainer":"QuizAnimation_quizAnimationContainer__r3Uh8","quizAnimation":"QuizAnimation_quizAnimation__bnDBH"};